/**
 * 退出登录：统一清理 Redux 持久化、Cookie、token 时间戳
 * 调用方需自行 dispatch(resetAppState()) 并跳转登录页
 */
import { clearTokenWithTimestamp } from '@/utils/helpers'
import { clearState } from '@/utils/localStorage'
import Session from '@/utils/session'

/**
 * 清理所有与登录相关的持久化数据（不包含 Redux 内存状态）
 * @param {string} [token] - 当前登录 token，用于清除 localStorage 中的 token_${token}
 */
export function clearAllAuth (token) {
  if (token) {
    clearTokenWithTimestamp(token)
  }
  clearState()
  Session.removeIkCookie()
}
